import { createSlice } from "@reduxjs/toolkit";

export const agentSlice = createSlice({
  name: "agent",
  initialState: {
    getAgentResult: false,
    getAgentLoading: false,
    getAgentError: false,
    addAgentResult: false,
    addAgentLoading: false,
    deleteAgentResult: false,
  },
  reducers: {
    agentReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_AGENT":
          return {
            ...state,
            getAgentResult: payload.data,
            getAgentLoading: payload.loading,
            getAgentError: payload.error,
          };
        case "ADD_AGENT":
          return {
            ...state,
            addAgentResult: payload.data,
            addAgentLoading: payload.loading,
          };
        case "DELETE_AGENT":
          return {
            ...state,
            deleteAgentResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { agentReducers } = agentSlice.actions;

export default agentSlice.reducer;
